import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import DesignerButton from './DesignerButton';
// eslint-disable-next-line
import { saveCookie, checkForCode, androidBackButton } from './Utils';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import penClick from './Sounds/pen-click.wav';

import rules1 from './Images/rules/rules_1.png';
import rules2 from './Images/rules/rules_2.png';
import rules3 from './Images/rules/rules_3.png';
import rules4 from './Images/rules/rules_4.png';
import rules5 from './Images/rules/rules_5.png';
import rules6 from './Images/rules/rules_6.png';
import rules7 from './Images/rules/rules_7.png';
import rules8 from './Images/rules/rules_8.png';
import rules9 from './Images/rules/rules_9.png';
import rules10 from './Images/rules/rules_10.png';
import rules11 from './Images/rules/rules_11.png';
import rules12 from './Images/rules/rules_12.png';
import rules13 from './Images/rules/rules_13.png';

class Rules extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;
    this.penClick = new Audio(penClick);

    this.state = {
      currentDot: 0,
    };
  }

  settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <></>,
    prevArrow: <></>,
    appendDots: dots => <div>{dots}</div>,
    afterChange: (index) => {
      this.state.currentDot = index
    },
  };

  componentDidMount() {
    androidBackButton(this.handleHasReadRules);

    saveCookie(this.props);
  }

  handleHasReadRules = () => {
    let code = this.props.cookies.get('code');
    checkForCode(
      'PUT',
      `/api/users/${code}/hasReadRules`,
      this.props,
      null
    ).then((data) => {
      console.log(data.message);
    });
    this.penClick.play();
    this.props.navigate(`/`);
  };

  render() {
    return (
      <div className="Home">
        <div className="arrowBackButtonDiv RulesBackArrow">
          <DesignerButton
            class="arrowBackButton"
            onClick={this.handleHasReadRules}></DesignerButton>
        </div>

        <div className="RulesCarouselContainer">
          <Slider {...this.settings}>
            <div className="RulesImages">
              <img src={rules1} width="375" height="750"/>
            </div>
            <div className="RulesImages">
              <img src={rules2} width="375" height="750"/>
            </div>
            <div className="RulesImages">
              <img src={rules3} width="375" height="750"/>
            </div>
            <div className="RulesImages">
              <img src={rules4} width="375" height="750"/>
            </div>
            <div className="RulesImages">
              <img src={rules5} width="375" height="750"/>
            </div>
            <div className="RulesImages">
              <img src={rules6} width="375" height="750"/>
            </div>
            <div className="RulesImages">
              <img src={rules7} width="375" height="750"/>
            </div>
            <div className="RulesImages">
              <img src={rules8} width="375" height="750"/>
            </div>
            <div className="RulesImages">
              <img src={rules9} width="375" height="750"/>
            </div>
            <div className="RulesImages">
              <img src={rules10} width="375" height="750"/>
            </div>
            <div className="RulesImages">
              <img src={rules11} width="375" height="750"/>
            </div>
            <div className="RulesImages">
              <img src={rules12} width="375" height="750"/>
            </div>
            <div className="RulesImages">
              <img src={rules13} width="375" height="750"/>
            </div>
          </Slider>
        </div>
      </div>
    );
  }
}

export default withCookies(Rules);
